export function insertTracks(
	existingTracks: Track[],
	newTracks: Track[],
	position: number
): Track[] {
	const result = [...existingTracks]

	if (position !== undefined) {
		result.splice(position, 0, ...newTracks)
	} else {
		result.push(...newTracks)
	}

	return result
}
